import {v4 as uuidv4} from 'uuid';
import img1 from '../../assets/img/client/1.jpg';

const TestimonialTwoData = [
  {
    id: uuidv4(),
    img: img1,
    name: 'Mohammed R.',
    designation: 'Homeowner, Dubai',
    speech:
      'Dhtech fixed my AC cooling issue the same day I called. The technicians were professional, explained everything clearly, and the pricing was transparent with no hidden charges. I highly recommend them for reliable AC service in the UAE.',
  },

  {
    id: uuidv4(),
    img: img1,
    name: 'Sara K.',
    designation: 'Facilities Manager, Abu Dhabi',
    speech:
      'We use Dhtech for regular AC maintenance across our offices and they have been outstanding. Their team responds quickly, keeps our systems running efficiently, and their 24/7 support has saved us from several emergencies.',
  },
];


export default TestimonialTwoData;